import React, { PureComponent } from 'react';
import styled, { css } from 'styled-components';
import { rgba, position } from 'polished';
import { color } from '@deerplusofficial/pos-helper';
import { Container as Base } from '../ButtonBase/ButtonBase';
import IconBase from '../Icon/Icon';
import Spinner from '../Spinner/Spinner';

export const Container = Base.extend`
  padding: 14px;
  position: relative;
  border-radius: 2px;
  color: ${props => props.color || color.primary};
  font-size: 14px;
  ${props =>
    props.tall &&
    css`
      line-height: 45px;
    `}
  ${props =>
    props.disabled &&
    !props.loading &&
    css`
      opacity: 0.5;
    `};
  ${props =>
    props.dense &&
    css`
      padding: 8px;
      line-height: 1;
      color: white;
    `};
  ${props =>
    props.cancel &&
    css`
      background-color: #fcfcfc;
      border: solid 1px #e6e6e6;
      color: ${rgba('#5e5e5e', 0.5)};
    `};
  ${props =>
    props.primary &&
    css`
      background-color: ${color.primary};
      border: 1px solid ${color.primary};
      color: white;
    `};
  ${props =>
    props.info &&
    css`
      background-color: ${color.text.title};
      border: solid 1px ${color.text.title};
      color: white;
    `}
  ${props =>
    props.accent &&
    css`
      background-color: ${color.accent};
      border: 1px solid ${color.accent};
      color: white;
    `};
  ${props =>
    props.secondary &&
    css`
      background-color: #fafafa;
      color: ${color.text.info};
      border: 1px solid ${color.border};
    `};
  ${props =>
    props.highlight &&
    css`
      background-color: #ffffff;
      color: ${color.primary};
      border: 1px solid ${color.primary};
    `};
  ${props =>
    props.ghost &&
    css`
      border: solid 1px #ffffff;
      color: white;
    `};
  ${props =>
    props.link &&
    css`
      text-decoration: underline;
    `};
`;

const Text = styled.div`
  ${props =>
    props.loading &&
    css`
      visibility: hidden;
    `};
`;

const LoadingIcon = styled(Spinner)`
  ${position('absolute', '50%', null, null, '50%')};
  transform: translate(-50%, -50%);
`;

const Icon = styled(IconBase)`
  margin-left: -14px;
  margin-right: 8px;
`;

class Button extends PureComponent {
  render() {
    const {
      children,
      loading,
      icon,
      disabled,
      secondary,
      ...props
    } = this.props;

    return (
      <Container
        loading={loading}
        disabled={loading || disabled}
        secondary={secondary}
        {...props}
      >
        <Text loading={loading}>
          {icon && <Icon icon={icon} />}
          {children}
        </Text>
        {loading && <LoadingIcon dark={secondary} />}
      </Container>
    );
  }
}

export default Button;



// WEBPACK FOOTER //
// ../pos-master/packages/pos-components/src/Button/Button.jsx